export const FK_COINS_TOOLTIP_CONTENT = {
    TEXT: "Save more on this order using your Flipkart Supercoins!",
};
